import { toRound } from '../../helpers/Format';
import React from 'react';
import { TypeDiscount } from '../../modules/DiscountReasons/IDiscount';
import { Texto } from './Texto';
import { Align } from '../../modules/ReceiptLayouts/Model';
export const Discount = ({ item }) => {
    if (item.totalDiscount) { // nueva implementación, descuento fijo o por porcentaje
        return React.createElement("div", null,
            React.createElement("p", { style: { margin: '0', padding: 0, textDecoration: 'line-through', fontWeight: 'normal', textAlign: 'end' } }, `Total  ${toRound(Math.abs(item.total) + item.totalDiscount)} ${item.money}`),
            React.createElement("p", { style: { margin: '0', padding: 0, textAlign: 'end' } }, item.typeDiscount === TypeDiscount.Percentage
                ? `${item.discount}% descuento: -${toRound(item.totalDiscount)} ${item.money}`
                : `Descuento: ${toRound(item.discount)} ${item.money}`),
            item.discountReason && React.createElement(Texto, { texto: item.discountReason, align: Align.Right }));
    }
    // antigua implementación, el tipo de descuento era fijo (dinero)
    return React.createElement("div", null,
        React.createElement("p", { style: { margin: '0',
                padding: 0,
                textDecoration: 'line-through',
                fontWeight: 'normal',
                textAlign: 'end' } }, `Total  ${toRound(Math.abs(item.total) + item.discount)} ${item.money}`),
        React.createElement("p", { style: { margin: '0', padding: 0, textAlign: 'end' } }, `Descuento: ${toRound(item.discount)} ${item.money}`));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Discount.tsx
// module id = 516
// module chunks = 0